import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import ImageWIthSignedUrl from "components/S3Utility/ImageWIthSignedUrl";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function SWoImportOptions({
  updatedSWo,
  setUpdatedSWo,
  selected,
  setSelected,
}) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */
  const [mProductTypes, setMProductTypes] = useState(null);
  const [mProductFabrics, setMProductFabrics] = useState(null);

  const [woProducts, setWOProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [loading, setLoading] = useState(null);

  /*   All Functions
   ********************************************* */
  //get M-Product Types Data
  const getProductTypesData = async () => {
    try {
      setLoading(true);

      const { data } = await API.post(
        "manufacturer/products/product-types",
        {
          filterBy: "all",
          page: 1,
          limit: 1000,
        },
        {
          headers: authHeader(),
        }
      );
      if (data.success) {
        setMProductTypes(data.data);

        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // get M-Product Fabrics data
  const getFabricsData = async () => {
    try {
      setLoading(true);

      let body = { page: 1, limit: 1000, filterBy: "all" };

      const { data } = await API.post("manufacturer/products/fabrics", body, {
        headers: authHeader(),
      });
      if (data.success) {
        setMProductFabrics(data.data);

        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //  Next Product
  const nextProduct = () => {
    if (woProducts?.length === 0) {
      return;
    }
    let currentIndex = woProducts.findIndex(
      (item) => item.id === selectedProduct.id
    );

    setSelectedProduct((prev) => null);
    if (currentIndex === -1) {
      setSelectedProduct((prev) => woProducts[0]);
      return;
    }

    // If the current index is the last index
    if (currentIndex === woProducts.length - 1) {
      return;
    }

    setSelectedProduct((prev) => woProducts[currentIndex + 1]);
  };

  //  Previous Product
  const prevProduct = () => {
    if (woProducts?.length === 0) {
      return;
    }

    let currentIndex = woProducts.findIndex(
      (item) => item.id === selectedProduct.id
    );

    setSelectedProduct((prev) => null);
    if (currentIndex === -1) {
      return;
    }

    // If the current index is the first index
    if (currentIndex === 0) {
      setSelectedProduct((prev) => woProducts[woProducts.length - 1]);
      return;
    }

    setSelectedProduct((prev) => woProducts[currentIndex - 1]);
  };

  const getProductNo = (selectedProduct) => {
    let index = woProducts.findIndex((item) => item.id === selectedProduct.id);
    return index + 1;
  };

  const handleProductSave = (key, value) => {
    let updatedProducts = woProducts.map((product) => {
      if (product.id === selectedProduct.id) {
        return {
          ...product,
          [key]: value,
        };
      }
      return product;
    });
    setUpdatedSWo((prev) => ({
      ...prev,
      WOProducts: updatedProducts,
    }));
  };

  const getProductTypeOfSelectedSProduct = () => {
    let salesWoProducts = selected?.WOProducts || [];

    if (!salesWoProducts || salesWoProducts.length === 0) {
      return null;
    }
    const selectedSalesProduct = salesWoProducts.find(
      (type) => type.id === selectedProduct?.id
    );
    if (!selectedSalesProduct) {
      return null;
    }

    return selectedSalesProduct.productType || "N/A";
  };

  const getProductFabricOfSelectedSProduct = () => {
    let salesWoProducts = selected?.WOProducts || [];

    if (!salesWoProducts || salesWoProducts.length === 0) {
      return null;
    }
    const selectedSalesProduct = salesWoProducts.find(
      (type) => type.id === selectedProduct?.id
    );
    if (!selectedSalesProduct) {
      return null;
    }

    return selectedSalesProduct.productFabric || "N/A";
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      getProductTypesData();
      getFabricsData();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (updatedSWo) {
      setWOProducts(updatedSWo?.WOProducts || []);

      if (selectedProduct) {
        setSelectedProduct(
          updatedSWo?.WOProducts.find(
            (item) => item.id === selectedProduct.id
          ) || null
        );
      } else {
        setSelectedProduct(updatedSWo?.WOProducts[0] || null);
      }
    }
  }, [updatedSWo]);

  return (
    <div>
      {loading && <Spinner />}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <h3>
            Products {getProductNo(selectedProduct)} of {woProducts.length}
          </h3>
        </div>
        <div className="d-flex gap-1 align-items-center">
          <button
            onClick={() => {
              prevProduct();
            }}
            disabled={selectedProduct?.id === woProducts[0]?.id}
            className={"btn btn-success btn-sm p-0 px-1 "}
          >
            <i className="mdi mdi-arrow-left-bold fs-3 py-0 my-0"></i>
          </button>
          <button
            onClick={() => {
              nextProduct();
            }}
            disabled={
              selectedProduct?.id === woProducts[woProducts.length - 1]?.id
            }
            className={"btn btn-success btn-sm p-0 px-1"}
          >
            <i className="mdi mdi-arrow-right-bold fs-3 py-0 my-0"></i>
          </button>
          {/* Back button */}
          <button
            className="btn btn-secondary"
            onClick={() => {
              setSelected(null);
            }}
          >
            Back
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-between gap-2">
        <div className="w-50 bg-light custom-border-radius-sm p-2">
          <h4 className="mb-1">Product Type</h4>
          <hr className="mt-0" />
          <div className="">
            <div className="d-flex justify-content-between align-items-center gap-1">
              <div className="w-50">
                <h5
                  className="mb-1 border-bottom border-3 pe-3"
                  style={{
                    width: "fit-content",
                  }}
                >
                  Sales Wo
                </h5>
                <div>{getProductTypeOfSelectedSProduct() || "N/A"}</div>
              </div>
              <div className="w-50">
                <h5
                  className="mb-1 border-bottom border-3 pe-3"
                  style={{
                    width: "fit-content",
                  }}
                >
                  Manufacturer Wo
                </h5>
                <select
                  value={selectedProduct?.productType || ""}
                  onChange={(e) => {
                    handleProductSave("productType", e.target.value);
                  }}
                  className="form-select form-select-sm"
                >
                  <option value="">Select Type</option>
                  {mProductTypes?.map((type) => (
                    <option key={type.productTypeId} value={type.type}>
                      {type.type}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="w-50 bg-light custom-border-radius-sm p-2">
          <h4 className="mb-1">Fabric</h4>
          <hr className="mt-0" />
          <div className="">
            <div className="d-flex justify-content-between align-items-center gap-1">
              <div className="w-50">
                <h5
                  className="mb-1 border-bottom border-3 pe-3"
                  style={{
                    width: "fit-content",
                  }}
                >
                  Sales Wo
                </h5>
                <div>{getProductFabricOfSelectedSProduct() || "N/A"}</div>
              </div>
              <div className="w-50">
                <h5
                  className="mb-1 border-bottom border-3 pe-3"
                  style={{
                    width: "fit-content",
                  }}
                >
                  Manufacturer Wo
                </h5>
                <select
                  value={selectedProduct?.productFabric || ""}
                  onChange={(e) => {
                    handleProductSave("productFabric", e.target.value);
                  }}
                  className="form-select form-select-sm"
                >
                  <option value="">Select Fabric</option>
                  {mProductFabrics?.map((type) => (
                    <option key={type.fabricId} value={type.name}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 bg-light my-2 p-3 flex-center custom-border-radius">
        {selectedProduct?.productImage ? (
          <ImageWIthSignedUrl
            imgStyle={{
              width: 300,
              height: 150,
            }}
            imgClasses="mb-2"
            path={selectedProduct?.productImage}
            alt="Image"
          />
        ) : (
          <>
            <h3>No Image Available</h3>
          </>
        )}
      </div>
    </div>
  );
}
